import { useEffect, useRef, useState } from 'react';

// Hide obsolete data during render, before the replacement effect starts.
export default function useCCResource(key, request) {
  const latest = useRef(request);
  latest.current = request;
  const [result, setResult] = useState({ key: null, status: 'idle', data: null });
  useEffect(() => {
    if (!key) return;
    const controller = new AbortController();
    const run = latest.current;
    setResult({ key, status: 'loading', data: null });
    Promise.resolve().then(() => {
      if (controller.signal.aborted) return undefined;
      return run(controller.signal);
    }).then((data) => {
      if (!controller.signal.aborted) setResult({ key, status: 'ready', data });
    }).catch((error) => {
      if (!controller.signal.aborted) {
        console.error('CC request failed', error.message);
        setResult({ key, status: 'error', data: null, error });
      }
    });
    return () => controller.abort();
  }, [key]);
  return !key ? { status: 'idle', data: null } : result.key === key ? result : { status: 'loading', data: null };
}
